import { useContext } from 'react';
import { TopbarContext } from './TopbarProvider';

function useTopBar() {
  return useContext(TopbarContext);
}

export default useTopBar;
